import { render, staticRenderFns } from "./importantDialog.vue?vue&type=template&id=540397dd&scoped=true"
import script from "./importantDialog.vue?vue&type=script&lang=js"
export * from "./importantDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "540397dd",
  null
  
)

export default component.exports